var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { ClassBaseDirective } from '../base/classbase.directive';
import { ClassService } from '../../service/class.service';
var TabGroupDirective = /** @class */ (function (_super) {
    __extends(TabGroupDirective, _super);
    function TabGroupDirective(el, renderer, service) {
        var _this = _super.call(this, el, renderer, service) || this;
        _this.el = el;
        _this.renderer = renderer;
        _this.service = service;
        _this.err_p = _this.renderer.createElement('p');
        return _this;
    }
    TabGroupDirective.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    TabGroupDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.renderer.listen(this.el.nativeElement, 'click', function () {
            _this.addError(_this.msg);
        });
    };
    TabGroupDirective.prototype.onInit = function () {
    };
    TabGroupDirective.prototype.addError = function (msg) {
        var errFlg = false;
        // エラーがあるタブはタブ名を赤字にする
        var menus = this.el.nativeElement.querySelector('.tabsMenu').children;
        var contents = this.el.nativeElement.querySelectorAll('.tabsContent');
        for (var i = 0; i < contents.length; i++) {
            var contentErr = contents[i].querySelector('.formError');
            if (contentErr) {
                // 赤字にする
                this.renderer.setStyle(menus[i].querySelector('a'), 'color', 'red');
                errFlg = true;
            }
            else {
                // 赤字から戻す
                this.renderer.removeStyle(menus[i].querySelector('a'), 'color');
            }
        }
        // エラーがあるときタブの上にメッセージを表示する
        var el = this.el.nativeElement.parentElement.querySelector('tab > .formError');
        if (errFlg) {
            if (!el) {
                this.err_text = this.renderer.createText(msg);
                this.renderer.addClass(this.err_p, 'formError');
                this.renderer.appendChild(this.err_p, this.err_text);
                this.renderer.insertBefore(this.el.nativeElement.parentNode, this.err_p, this.el.nativeElement);
            }
        }
        else {
            if (el) {
                this.renderer.removeChild(this.err_p, this.err_text);
                this.renderer.removeChild(this.el.nativeElement.parentNode, this.err_p);
            }
        }
    };
    TabGroupDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[tabDir]'
                },] }
    ];
    /** @nocollapse */
    TabGroupDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ClassService }
    ]; };
    TabGroupDirective.propDecorators = {
        msg: [{ type: Input }]
    };
    return TabGroupDirective;
}(ClassBaseDirective));
export { TabGroupDirective };
//# sourceMappingURL=tab.directive.js.map